import React from 'react';  
import Layout from '../../components/UI/Layout/Layout'
import MyChartComponent from "../../components/UI/Charts/mychart";
import MyComponent from "../../components/UI/Inputs/Inputs";
import InputCounter from "../../components/UI/Inputs/InputCounter";

function Statistics() {

  const options = ['Apple', 'Banana', 'Cherry', 'Durian', 'Elderberry'];

 

  return <Layout>
      Statistics
      <h2>test!</h2>
      <MyChartComponent covidData={[44, 17, 15]} /> 
      <InputCounter />
      <InputCounter />
      <InputCounter />
      <InputCounter />
      <InputCounter />
      <InputCounter />
      <InputCounter />

      <MyComponent />
  </Layout> ;
}

export default Statistics;
